<template>
  <div>
    <el-tabs>

      <!-- 预警历史 -->
      <el-tab-pane :label="$t('message.alert')">
        <div>
          <el-table :data="terminalAlertHistories" border stripe height="400">
            <!-- 警告类型 -->
            <el-table-column :label="$t('message.type')" prop="type">
              <template slot-scope="scope">
                <div class="typeHref" @click="showAlertDetail(scope.row)">
                  <span v-if="scope.row.type == 1">{{$t('message.appTaskFailure')}}</span>
                  <span v-else-if="scope.row.type == 2">{{$t('message.terminalMove')}}</span>
                  <span v-else-if="scope.row.type == 3">{{$t('message.tamper')}}</span>
                  <span v-else-if="scope.row.type == 4">{{$t('message.lowMemory')}}</span>
                  <span v-else-if="scope.row.type == 5">{{$t('message.printerAgeing')}}</span>
                  <span v-else-if="scope.row.type == 6">{{$t('message.batteryAgeing')}}</span>
                  <span v-else>{{$t('message.otherError')}}</span>
                </div>
              </template>
            </el-table-column>

            <!-- 时间 -->
            <el-table-column :label="$t('message.date')" prop="localReportTime" />

            <!-- 警告等级 -->
            <!-- 说明：level > 3 则警告级别为高级， level <= 3 警告级别为中级 -->
            <el-table-column :label="$t('message.level')" prop="level">
              <template slot-scope="scope">
                <div v-if="scope.row.level > 3">
                  <span class="middle-icon"></span>
                  <span>{{$t('message.middle')}}</span>
                </div>
                <div v-else>
                  <span class="high-icon"></span>
                  <span>{{$t('message.high')}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination class="history-pagination" background layout="prev, pager, next" @current-change="queryTerminalAlertHistory" :current-page="pageNum" :page-count="pages" />
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: "TerminalEditHistory",

    props: {
      terminalId:{
        required: true
      }
    },

    data(){
      return{
        /*--------------------------------------------- 分页信息 ---------------------------------------------*/
        pageSize: 10,
        pageNum: 1,
        pages: 0,

        terminalAlertHistories:[], // 预警历史
      }
    },

    watch:{
      terminalId:function(){
        this.queryTerminalAlertHistory(1);
      }
    },

    methods: {
      queryTerminalAlertHistory(pageNum){
        let _this = this,
          obj = {
            pageNum: pageNum,
            pageSize: this.pageSize,
            terminalId: this.terminalId
          };
        this.$axios({
          method: 'post',
          url: '/marketplace/alertHistory/terminalEdit/page',
          data: obj,
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
        }).then(response => {
          if (response.data.code != "00") {
            _this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.pages = response.data.data.pages;
            this.terminalAlertHistories = response.data.data.list;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
    }

  }
</script>

<style scoped>
  .high-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #db1e08;
    border: 3px solid #f5c8c2;
  }

  .middle-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #fdb201;
    border: 3px solid #fdecbe;
  }

  .history-pagination {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditHistory.vue